import React, {useEffect,useState} from 'react';
import floaderIcon from '../Assets/Icons/floader.png'

const NoDataCard = ({ message = "No Data to display", height = '100%'}) => {
    const [isSmallScreen, setIsSmallScreen] = useState(window.innerWidth < 720)
      // Update screen width on resize
  useEffect(() => {
    const handleResize = () => {
      setIsSmallScreen(window.innerWidth < 720);
    };

    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);
    const containerStyle = {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        height: height,
        textAlign: 'center',
        padding: '16px',
        // backgroundColor: '#f9fafb', // Light gray background
        // borderRadius: '8px',
        // boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
    };

    const iconStyle = {
        width: isSmallScreen ? '40px' : '60px',
        height: isSmallScreen ? '40px' : '60px'
    };

    const messageStyle = {
        paddingTop: '10px',
        fontFamily: 'Roboto Slab',
        fontSize: isSmallScreen ? '14px' :'16px',
        fontWeight: 400,
        lineHeight: '23.74px',
        letterSpacing: '0.01em',
    };

    const subMessageStyle = {
        fontSize: '14px',
        color: '#718096', // Medium gray
        marginTop: '8px',
    };

return (
    <div style={containerStyle}>
        <img src={floaderIcon} alt={''} style={iconStyle} />
        <h2 style={messageStyle}>{message}</h2>
    </div>
);
};

export default NoDataCard;
